import Comp from './MultiEventFeedBack'
export default Comp
